import { TextInput, TextInputReadOnly } from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { InputWithSpecialSyntax } from "./InputWithSpecialSyntax";
import { localize } from "client_legacy/ndaw/culture";

type ExpressionTextInputProps = {
	isReadOnly: boolean;
	attachable: IValueInputAttachable<string>;
	placeholder?: string;
};

export const ExpressionTextInput = (props: ExpressionTextInputProps): ReactElement => {
	const {
		isReadOnly,
		attachable,
		placeholder: placeholderFromProps
	} = props;

	const placeholder: string = placeholderFromProps ?? localize("_EnterFieldName");

	return (
		<>
			{isReadOnly
				? (
					<TextInputReadOnly
						{...attachable.attachToTextInput()}
					/>
				)
				: (
					<InputWithSpecialSyntax kind="expression">
						<TextInput
							{...attachable.attachToTextInput()}
							placeholder={placeholder}
						/>
					</InputWithSpecialSyntax>
				)
			}
		</>
	);
};
ExpressionTextInput.displayName = "ExpressionTextInput";